import React from 'react';
import { Routes, Route } from "react-router-dom";
import MakerReportsModule from './rr-maker-reports-module/maker-reports-module';

const RRMakerReports = () => {
  return (
    <Routes>
      <Route index element={<MakerReportsModule />} />
    </Routes>
  )
}

export default RRMakerReports;



